export const LANG = {
  pt: {
    LANGUAGE: 'pt',
    ARTICLES: {
      QUESTIONS: {
        AGREE_INFO_RAPPI:
          'Você está feliz com as informações fornecidas pelo seu Rappi?',
        HOW_SOLVE_YOUR_PROBLEM:
          'Como você gostaria que resolvêssemos seu problema?',
        KIND_OF_DOUBT: 'Tipo de dúvida',
        KIND_OF_DAMAGE_ORDER: 'Que tipo de dano seu pedido teve?',
        PRODUCT_BAD_STATUS: 'Qual produto você recebeu em más condições?',
        USER_COMMENT: 'Comentário do usuário:',
        PRODUCT_DESCRIPTION: 'Produtos relacionados nesta ordem',
      },
    },
    HOME: {
      TITLE: 'Página principal',
    },
    NOT_FOUND: {
      TITLE: 'A página solicitada não foi encontrada',
    },
    WIDGETS: {
      BILLING_INFORMATION: {
        CHARGE_DEDUCTED: 'Cobrança deduzida do seu cartão',
        COUPON_DISCOUNT: 'Cupom de desconto',
        DELIVERY_COST: 'Custo de entrega',
        DIFFS_PERSONAL_SHOPPER: 'Diferença de preços no personal shopper',
        DISCOUNTS: 'Descontos',
        OTHER_TOTAL_CHARGES: 'Outras cobranças',
        PRIME_DISCOUNT: 'Prime Descontos',
        PRODUCT_DISCOUNT_BY_RAPPI: 'Descontos de produtos por rappi',
        PRODUCT_DISCOUNT_BY_STORE: 'Descontos de produtos por loja',
        PROMOTION_DISCOUNT: 'Promoção de desconto',
        SUBTOTAL_PRODUCTS: 'Produtos subtotais',
        SUPPORT_DISCOUNT: 'Descontos Lupe',
        TOTAL_COSTS: 'Total custos',
        TOTAL_DISCOUNTS: 'Descontos totais',
        TOTAL_PAID_BY: 'Total pago por ',
        TOTAL_PAYMENTS: 'Total de pagamentos',
        TRANSACTIONS_TO_YOUR_CARD: 'Transações para o cartão',
        WHIM_COST: 'Custos de capricho',
      },
      CALL_RT: {
        YOUR_RAPPI: 'Seu Rappi',
      },
      CALL_RESTAURANT: {
        TITLE: 'Ligar restaurante',
        YOUR_ORDER_ID: 'O número do seu pedido é',
      },
      CALL_SUPPORT: {
        TITLE: 'Suporte de chamadas',
        HOW_CALL: 'Como você quer ligar ?',
        PHONE: 'Telefone',
        DATA: 'Dados',
        SIMPLE_CALL_SUPPORT: 'ligue para suporte',
        THIS_IS_AN_ERROR: 'Se você acha que isso é um erro, ',
      },
      CLOSE_REQUEST: {
        TITLE: 'Finalizar pedido',
      },
      COMMON: {
        MESSAGE_SEND: 'Mensagem enviada!',
        CONTACT_EMAIL: 'Nós entraremos em contato por e-mail',
        LEGAL_TIME: 'Em menos de 72 horas, teremos uma resposta.',
        AND_SUPPORT_SECTION_APP: 'e na seção Suporte do aplicativo',
        UNDERSTOOD: 'Entendido',
        OK: 'OK!',
        RATE_US: 'Por favor, classifique o nosso serviço...',
        REQUEST_ERROR:
          'Houve um problema e não foi possível receber sua solicitação. Por favor, tente novamente mais tarde.',
        DOWNLOAD_DOCUMENT_COPY: 'Você pode baixar uma cópia da sua reclamação',
        HERE: 'aqui',
      },
      DEEP_LINK_CART: {
        ALREADY_APPLIED_RAPPICREDITS:
          'Já aplicamos o Créditos à sua conta para que você peça o que deseja.',
      },
      OPTION_LIST: {
        TITLE: 'Escolha uma opção',
        PLEASE_COMPLETE: 'por favor nos diga {question}',
      },
      RT_DISPERSION: {
        GET_INTO: 'Entrar',
        AMOUNT: 'A quantidade',
        CONFIRMATION: 'Recebemos seu pedido de dispersão!',
        IN_REVISION:
          'Nós já estamos revisando sua solicitação, em alguns minutos nós lhe daremos a resposta',
      },
      TIMER: {
        IMMEDIATE_HELP: 'Você precisa de ajuda imediata?',
        IN_THE_NEXT: 'Durante o próximo',
        MINUTES_OPEN_ORDER:
          'minutos este pedido será aberto para resolver qualquer problema',
        DIALOG_TITLE: 'Informação',
        DIALOG_TEXT:
          'Se você precisar de ajuda com esse pedido, acesse a Central de Ajuda',
        DIALOG_CLOSE_BUTTON: 'Entendido',
      },
      TRANSACTION_DETAIL: {
        TYPE: 'Tipo',
        AMOUNT: 'Quantidade',
        DATE: 'Data',
        COPY:
          'Na seguinte tabela, você pode conferir todas as transações feitas no seu cartão de crédito. Às vezes fazemos uma pré-autorização, que não é uma cobrança, e sim uma reserva que nos permite confirmar que você tem saldo suficiente.',
        INFO_BOX: {
          COPY: 'Dependendo do seu banco, pode demorar um pouco para atualizar',
        },
        TOTAL_COPY: 'Total pago',
      },
      PRODUCTS_WRAPPER: {
        WHIMS: 'Caprichos',
      },
      INPUT: {
        MAX_LENGTH: 'Você atingiu o máximo de caracteres',
      },
      TEXT_AREA: {
        TITLE: 'Escreva-nos sua mensagem',
        PLACEHOLDER: 'Escreva aqui',
      },
      BUTTON: {
        SEND: 'Enviar',
      },
      CLOSE_REORDER_PRODUCTS_FLOW_WIDGET: {
        COVID_19:
          'Devido ao cenário atual e aumento de nossa demanda nossas operações de atendimento estão atuando em sua máxima capacidade, pedimos sua compreensão porque podemos demorar mais que o usual para atendê-lo.',
      },
      HELP_OPTIONS: {
        TITLE: 'Você tem problemas com o seu pedido?',
      },
      MULTIPLE_ATTENTION_CHANNELS: {
        TITLE: 'Favor fornecer detalhes adicionais',
        BODY: 'Conte-nos em detalhes o que aconteceu',
        EMAIL: 'Enviar',
        CHAT: 'Ou Chat',
        CHANNEL_SUBTITLE: 'Canal pelo qual você deseja ser veiculado',
      },
      COST_DISCOUNTS: {
        COST_MESSAGE: 'Sua carga',
        COST_TITLE: 'Custos',
        DISCOUNT_TITLE: 'Descontos',
        IVA: 'O preço total inclui IVA',
        MODAL_SERVICE_FEE: {
          TITLE: 'Taxa de Serviço Rappi (Serviço)',
          TEXT:
            'É uma taxa adicional cobrada pela plataforma Rappi ao usuário/consumidor em compras feitas em parceiros comerciais da Rappi. Essa taxa é cobrada para ajudar a cobrir os custos de tecnologia, desenvolvimento de novas funções no aplicativo, ações de marketing e custos da plataforma de processamento de pagamentos.',
        },
      },
      PAYMENTS_RT: {
        PUBLIC_COMMENT_RANGE: 'Data de pagamento: {range}',
        PUBLIC_COMMENT_AMOUNT: 'Montante: {amount}',
        NO_PAYMENTS: 'sem registros encontrados',
        PAYMENTS_SELECT_WARNING_TOAST: 'Selecione um período.',
        PAYMENTS_TEXT_TOAST: 'Fizemos um pagamento em sua conta registrada.',
        PAYMENTS_TEXT_FIRST:
          'Fizemos um pagamento em sua conta registrada  no valor de',
        PAYMENTS_TEXT_LAST:
          'qualquer preocupação adicional sobre esse pagamento, faça com as opções de saldo da dívida ou ganhe.',
        USER_DEBT:
          'A dívida nesse período foi maior que o ganh e por isso nenhum depósito foi feito.',
        DATE_PLACEHOLDER: 'Selecione a data',
        AMOUNT_PLACEHOLDER: 'Montante pendente (opcional)',
      },
      SCREEN_SATISFACTION: {
        TITLE: 'Preciso de ajuda',
        MANDATORY_MSJ: 'Obrigatório',
      },
      PRODUCTS_LIST: {
        TITLE: 'Sumario de Productos',
        DELETED_TITLE: 'Eliminado',
        FRESHNESS_GUARANTEE: 'Qual produto não é fresco?',
        FRESHNESS_COUNTER_TITLE: 'Selecione as unidades'
      },
      ZENDESK_ARTICLE: {
        RETURN_BUTTON: 'Atrás'
      },
    },
    COMPONENTS: {
      PRODUCT: {
        UNIT: 'Unidade',
        UNITS: 'Unidades',
      },
      INFO_BOX: {
        COPY:
          'Obrigado pela resposta! Vamos a utilizar para melhorar sua experiência.',
      },
      ORDER_PRODUCT: {
        UNIT: 'Unidade',
        UNITS: 'Unidades',
        HIDE: 'Ocultar',
        SHOW: 'Mostrar',
      },
      PRODUCTS_WRAPPER: {
        TITLE: 'Qual produto você precisa?'
      }
    },
    COMMON: {
      YES: 'Sim',
      NO: 'Não',
      COPY_TO_CLIPBOARD: 'Copiado para a área de transferência',
      PHONE: 'Telefone',
      COSTS: 'Custos',
      TIP: 'Gorjeta',
      RAPPI_PAY: 'Rappipay',
      RAPPI_CREDITS: 'Créditos',
      MIN_CHARACTERS: {
        TEXT_AREA: 'Campo de Texto',
        BASE:
          '@:COMMON.MIN_CHARACTERS.TEXT_AREA requer um mínimo de caracteres de {minLength}',
      },
      REQUIRED_IMAGE: {
        BASE: 'Pelo menos {n} imagem é necessária',
      },
      REQUIRED_PRODUCT: {
        BASE: 'Você deve selecionar pelo menos um produto.',
        OVERLOAD:
          'Se seu pedido não foi entregue, por favor crie a solicitação de pedido não entregue.',
      },
      REQUIRED_INPUT: 'Por favor, preencha o campo de texto',
      SECONDS: 'Segundos',
      MINUTES: 'Minutos',
      HOURS: 'Horas',
      DAYS: 'Dias',
      WAIT_TIME: 'Tempo de espera',
      ERROR_MESSAGE: 'Desculpe, ocorreu um erro.'
    },
    MODALS: {
      COMPENSATION: {
        COMPENSATION_QUESTION: 'Como você quer que compensemos você?',
        RAPPICREDITCS_REFUND: 'Reembolso em créditos do Rappi',
        PRODUCTS_RESHIP: 'Encaminhamento de produtos ausentes',
        REFUND_TEXT: 'O valor dos pedidos perdidos era $',
      },
    },
    PAYMENT_METHOD: {
      CASH: 'Em Dinheiro',
      CC: 'Cartão de crédito',
      DC: 'Tarjeta débito',
      PAYPAL: 'PayPal',
      POS_TERMINAL: 'Dataphone',
      TERMINAL: 'Terminal',
      RAPPI_PAY: 'Rappipay',
    },
    MAXLENGTH_MESSAGE: 'Caracteres permitidos',
  },
}
